<div *ngIf="actualCompany" class="row row-page-title page-row">

  <div class="title-page-col">

    <h1 class="page-title">
      {{ actualCompany.name }}
    </h1>

  </div>

  <div class="title-button-col">

    <button
      class="btn-principal"
      style="width: 157px"
      routerLink="/company"
    >
      Voltar
    </button>

  </div>

</div>

<p class="page-subtitle sub-alone">
  Empresa
</p>

<form
  *ngIf="companieForm"
  [formGroup]="companieForm"
  (ngSubmit)="onSubmit()"
  style="text-align: unset"
>

  <div
    *ngIf="actualCompany"
    class="row row-content page-row"
  >

    <div class="col-info-input">

      <p class="page-subtitle">
        Nome
      </p>

      <input
        formControlName="name"
        type="text"
        [ngClass]="{
          'border-red':
            (!companieForm.controls.name.valid) &&
            (companieForm.controls['name'].touched)
        }"
        placeholder="Nome Empresa"
        [value]="actualCompany.name"
        class="search-input"
      >

      <app-form-errors
        [errorMsg]="'Campo Obrigátorio!'"
        *ngIf="
          !companieForm.controls.name.valid &&
          companieForm.controls['name'].touched
        "
      ></app-form-errors>

    </div>

    <div class="col-info-input">

      <p class="page-subtitle">
        Data Limite para Acesso
      </p>

      <input
        type="date"
        [ngClass]="{
          'border-red':
            (!companieForm.controls.expirationDate.valid) &&
            (companieForm.controls['expirationDate'].touched)
        }"
        placeholder="Data Limite Acesso"
        formControlName="expirationDate"
        class="search-input user-input"
        [(ngModel)]="dataLimiteFormatada"
        [value]="dataLimiteFormatada"
      >

      <app-form-errors
        [errorMsg]="'Campo Obrigátorio!'"
        *ngIf="
          !companieForm.controls.expirationDate.valid &&
          companieForm.controls['expirationDate'].touched
        "
      ></app-form-errors>

    </div>

    <div class="col-info-input" style="width: 21.7%">

      <p class="page-subtitle">
        Situação
      </p>

      <select
        name="situation"
        id="situation"
        class="select-input info-input"
        formControlName="isActive"
      >
        <option [ngValue]="isActive" *ngFor="let isActive of situation">
          {{(!isActive) ? 'Inativo' : 'Ativo'}}
        </option>

      </select>

    </div>

    <div class="col-info-input" style="width: 41%;">

      <p class="page-subtitle">
        Token Identificação Motel
      </p>

      <input
        formControlName="apiToken"
        type="text"
        readonly
        placeholder=" Token Identificação Motel"
        [value]="actualCompany.apiToken"
        class="search-input"
      >

    </div>

    <button
      type="button"
      class="btn-principal"
      (click)="regenerateApiToken()"
      style="width: 122px; height: 38px; margin: auto 0 40px;"
    >
      Regerar
    </button>

  </div>

  <p class="page-subtitle sub-alone">
    Usuários
  </p>

  <div class="row page-row row-content">

    <table
      mat-table
      [dataSource]="userDataSource"
      style="width: 100%; margin: 0px;"
    >

      <ng-container matColumnDef="Name">

        <th
          mat-header-cell
          *matHeaderCellDef
          class="table-header-labels table-cell"
        >
          Nome
        </th>

        <td
          class="table-cell"
          mat-cell
          *matCellDef="let element"
          style="text-align: left; padding-left: 20px; width: 33%;"
        >
          {{element.username}}
        </td>

      </ng-container>

      <ng-container matColumnDef="apiToken">

        <th
          mat-header-cell
          *matHeaderCellDef
          class="table-header-labels table-cell"
        >
        Token de Autorização
        </th>

        <td
          class="table-cell"
          mat-cell
          *matCellDef="let element"
          style="text-align: left; padding-left: 20px; width: 33%;"
        >
          {{element.apiToken}}
        </td>

      </ng-container>

      <ng-container matColumnDef="isActive">

        <th
          mat-header-cell
          *matHeaderCellDef
          class="table-header-labels table-cell"
        >
          Situação
        </th>

        <td
          mat-cell
          *matCellDef="let element"
          [ngClass]="{'inactive-company': element.isActive !== true}"
          class="table-cell"
        >
          {{(element.isActive === true) ? 'Ativo' : 'Inativo'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">

        <th
          mat-header-cell
          *matHeaderCellDef
          class="table-header-labels table-cell"
        >
          Ações
        </th>

        <td
          mat-cell
          *matCellDef="let element"
          class="table-cell"
        >
          <button type="button" (click)="changeAdmin(element.id, element.username)" *ngIf="!element.isAdmin && !element.isFixo" class="btn-principal">
            Tornar Admin
          </button>
          <span class="role admin" *ngIf="element.isAdmin">Administrador</span>
          <span class="role" *ngIf="!element.isAdmin && element.isFixo">Usuário Padrão</span>
          
        </td>
      </ng-container>

      <tr class="table-header-row" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

  </div>

  <p class="page-subtitle sub-alone">
    Grupos
  </p>

  <div class="row page-row row-content">

    <table
      mat-table
      style="width: 100%; margin: 0px;"
      [dataSource]="holdingDataSource"
    >

      <ng-container matColumnDef="Name">

        <th
          mat-header-cell
          *matHeaderCellDef
          class="table-header-labels table-cell"
        >
          Nome
        </th>

        <td
          class="table-cell"
          mat-cell
          style="text-align: left; padding-left: 20px;"
          *matCellDef="let element"
        >
          {{element.name}}
        </td>

      </ng-container>

      <tr class="table-header-row" mat-header-row *matHeaderRowDef="displayedColumnHolding"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnHolding;"></tr>

    </table>

  </div>

  <div class="col-12 col-alone-btn">

    <button
      type="submit"
      class="btn-principal"
      style="width: 122px; margin-bottom: 30px"
      [disabled]="companieForm.invalid || submitMode"
    >
      Salvar
    </button>

  </div>

</form>

<ngx-ui-loader
  [fgsColor]="loaderConfig.fgsColor"
  [fgsPosition]="loaderConfig.fgsPosition"
  [fgsSize]="loaderConfig.fgsSize"
  [fgsType]="loaderConfig.fgsType"
  [bgsColor]="loaderConfig.bgsColor"
  [bgsOpacity]="loaderConfig.bgsOpacity"
  [bgsPosition]="loaderConfig.bgsPosition"
  [bgsSize]="loaderConfig.bgsSize"
  [bgsType]="loaderConfig.bgsType"
  [gap]="loaderConfig.gap"
  [logoPosition]="loaderConfig.logoPosition"
  [logoSize]="loaderConfig.logoSize"
  [logoUrl]="loaderConfig.logoUrl"
  [overlayColor]="loaderConfig.overlayColor"
  [pbColor]="loaderConfig.pbColor"
  [pbDirection]="loaderConfig.pbDirection"
  [pbThickness]="loaderConfig.pbThickness"
  [hasProgressBar]="loaderConfig.hasProgressBar"
  [text]="loaderConfig.text"
  [textColor]="loaderConfig.textColor"
  [textPosition]="loaderConfig.textPosition"
></ngx-ui-loader>
